// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3iFGy","inputWrap":"CustomTip_inputWrap__rzE_w"};